export const getSearchResults = state => state.fetchedData.dataFetched;
export const getIndicators = state => state.indicators;
export const getFavouritesList = state => state.favItems.list;
export const getFavouritesListIds = state => state.favItems.ids;
export const getWatchList = state => state.watchListItems.list;
